import { Injectable } from '@angular/core';
import { SchemaObject, TableColumn } from './openapi-schema';

@Injectable({ providedIn: 'root' })
export class ReportBuilderService {

  buildColumns(schema: SchemaObject, parentKey = ''): TableColumn[] {
    if (!schema || !schema.properties) return [];
    
    return Object.entries(schema.properties).map(([key, propSchema]) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      const column: TableColumn = {
        key: fullKey,
        title: propSchema.title || key,
        type: propSchema.type,
        schema: propSchema,
        children: []
      };

      if (propSchema.type === 'object' && propSchema.properties) {
        column.children = this.buildColumns(propSchema, fullKey);
      } else if (propSchema.type === 'array' && propSchema.items) {
        column.children = this.buildColumns(propSchema.items, fullKey);
      }

      return column;
    });
  }

  getValue(data: any, path: string): any {
    if (!data || !path) return undefined;
    return path.split('.').reduce((obj, key) => (obj ? obj[key] : undefined), data);
  }

  getLeaves(columns: TableColumn[]): TableColumn[] {
    return columns.reduce((acc: TableColumn[], col) => {
      if (col.children && col.children.length > 0) {
        return [...acc, ...this.getLeaves(col.children)];
      }
      return [...acc, col];
    }, []);
  }

  getMetadataSections(schema: SchemaObject): TableColumn[] {
    if (!schema || !schema.properties) return [];
    
    return Object.entries(schema.properties).map(([key, propSchema]) => {
      return {
        key,
        title: propSchema.title || key,
        type: propSchema.type,
        schema: propSchema,
        children: propSchema.properties ? 
                 this.getMetadataSections(propSchema) : 
                 []
      };
    });
  }
}